<template>
    <h1>Lista de Avaliações Ascendentes</h1>
    <AssessmentQuestionaireManagementTable 
        :assessment-type="'ascending'"
    />
</template>
<script setup>
import AssessmentQuestionaireManagementTable from '@/components/assessments/questionaires/AssessmentQuestionaireManagementTable.vue';


</script>